import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/metaPixel';

// Fires PageView on first load and again on every route change.
//
// The base snippet in index.html deliberately does not fire PageView: in a
// single-page app the browser only loads the document once, so without this
// every visit would report one page view no matter how far the customer went.
// Keeping it here instead of in both places is also what stops the landing
// page being counted twice.
const MetaPixelPageViews = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView();
  }, [pathname, search]);

  return null;
};

export default MetaPixelPageViews;
